





































































import { PropType, computed, defineComponent, ref } from '@vue/composition-api';

import { IWorkflowTransition } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';

import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IRootState } from '@/store';
import {
  IWorkflowStoreState,
  IWorkflowGetters,
  IWorkflowActions,
  IWorkflowMutations
} from '@/store/workflow';

import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { useEdge, useWorkFlow } from '../workflow-canvas/composables';
import { useNodeConnections } from '../workflow-canvas/composables/useNodeConnections';
import { HexToRGB } from '@/utils/colorUtils';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'WorkflowTransitionDetailOptionsButton',

  components: {
    ConfirmationDialog,
    DetailOptionsButton
  },

  mixins: [auth],

  props: {
    workflowId: {
      type: Number,
      required: true
    },
    transition: {
      type: Object as PropType<IWorkflowTransition>,
      required: true
    },
    readonly: {
      type: Boolean
    }
  },

  setup(props, { emit }) {
    const { id, edge } = useEdge<IWorkflowTransition>(
      props.transition.id?.toString()
    );
    const {
      workFlowRef,
      fitBounds,
      findEdge,
      findNode,
      removeEdges
    } = useWorkFlow();

    const connections = useNodeConnections({
      nodeId: computed(() => props.transition.id!.toString())
    });

    const transitionConnections = computed(() =>
      connections.value.map(connection => {
        return {
          transition: findEdge<IWorkflowTransition>(connection.edgeId)?.data,
          sourceTransition: findNode<IWorkflowTransition>(connection.source)
            ?.data
        };
      })
    );

    const store = useStore<IRootState>();

    const { useActions } = createNamespacedHelpers<
      IWorkflowStoreState,
      IWorkflowGetters,
      IWorkflowActions,
      IWorkflowMutations
    >(store, 'workflow');

    const { deleteWorkflowTransition } = useActions([
      'deleteWorkflowTransition'
    ]);

    const error = ref<ISystemError | null>(null);

    function clearErrors() {
      error.value = null;
    }

    const transitionDeleteInProgress = ref(false);

    const deleteTransitionDialog = ref(false);

    function cancelTransitionDeleteDialog() {
      deleteTransitionDialog.value = false;
    }

    async function removeTransition() {
      const transitionId = props.transition.id!;

      try {
        transitionDeleteInProgress.value = true;
        await deleteWorkflowTransition({
          workflowId: props.workflowId!,
          transitionId: transitionId!
        });

        removeEdges(transitionId.toString());
        emit('deleted-transition', transitionId.toString());

        deleteTransitionDialog.value = false;
      } catch (err) {
        error.value = setErrorFromAxiosError(err as AxiosError);
      } finally {
        transitionDeleteInProgress.value = false;
      }
    }

    function centerTransitionOnCanvas() {
      console.log(id, edge);

      // fitView({ edges: [String(props.transition.id)], duration: 280 }).then(
      //   () => {
      //     emit('center-transition-on-canvas');
      //   }
      // );
      const edgeEl = workFlowRef.value?.querySelector(
        `.workflow__edge[data-id="${id}"]`
      );

      if (edgeEl) {
        const bounds = edgeEl.getBoundingClientRect();
        console.log({ edgeEl, bounds });
        const boundRect = {
          height: 33.724609375,
          width: 236.072265625,

          x: 764.2587890625,
          y: 282.2436828613281
        };

        fitBounds(boundRect, { duration: 280 }).then(() => {
          emit('center-transition-on-canvas');
        });
      }
    }

    const isDisplayingConnections = ref(false);

    return {
      error,
      deleteTransitionDialog,
      transitionDeleteInProgress,

      cancelTransitionDeleteDialog,
      removeTransition,
      clearErrors,
      centerTransitionOnCanvas,

      transitionConnections,
      isDisplayingConnections,

      hexToRGB: HexToRGB
    };
  }
});
